import React, { useEffect, useState } from 'react'
import { useAtom } from 'infrastructure/state/jotai.wrapper'
import { editedConfigAtom } from './atoms'
import { Box, Button, TextField } from '@mui/material'
import { NodeTypeSelect } from '../../components/tree/utility/NodeTypeSelect'
import { useHasChanges } from './hooks'
import { ChangeableContent } from './utility'
import { IngestionConfigItem } from './types'
import { camelToTitle } from '../../components/Helpers'

export function DestinationType({ configKey }: { configKey: string }) {
  const [editing, setEditing] = useState(false)
  const [editedConfig, setEditedConfig] = useAtom(editedConfigAtom)
  const { topLevelHasChanges } = useHasChanges()

  if (!editedConfig) return null

  const { destinationType } = editedConfig[configKey]

  const changed = topLevelHasChanges(configKey, 'destinationType')

  const onChange = (destinationType: string) => {
    setEditedConfig((prev = {}) => ({
      ...prev,
      [configKey]: {
        ...prev[configKey],
        destinationType,
      },
    }))
  }

  return (
    <Box>
      <ChangeableContent changed={changed}>
        Destination Type:{' '}
      </ChangeableContent>
      {!editing && <em>{destinationType}</em>}
      {editing && (
        <NodeTypeSelect type={destinationType ?? ''} onSelect={onChange} />
      )}
      <Button onClick={() => setEditing(!editing)}>
        {editing ? 'Done' : 'Edit'}
      </Button>
    </Box>
  )
}

export function DestinationTitle({ configKey }: { configKey: string }) {
  return (
    <TopLevelConfigItem
      configKey={configKey}
      topLevelKey={'destinationTitle'}
    />
  )
}

export function CustomNodeTitle({ configKey }: { configKey: string }) {
  return (
    <TopLevelConfigItem configKey={configKey} topLevelKey={'customNodeTitle'} />
  )
}

function TopLevelConfigItem({
  configKey,
  topLevelKey,
}: {
  configKey: string
  topLevelKey: keyof IngestionConfigItem
}) {
  const [itemValue, setItemValue] = useState('')
  const [editing, setEditing] = useState(false)
  const [editedConfig, setEditedConfig] = useAtom(editedConfigAtom)
  const { topLevelHasChanges } = useHasChanges()

  const changed = topLevelHasChanges(configKey, topLevelKey)

  useEffect(() => {
    setItemValue(String(editedConfig?.[configKey]?.[topLevelKey]))
  }, [editedConfig, configKey, topLevelKey])

  if (!editedConfig) return null

  const onBlur = () => {
    setEditedConfig((prev = {}) => ({
      ...prev,
      [configKey]: {
        ...prev[configKey],
        [topLevelKey]: itemValue,
      },
    }))
  }

  return (
    <Box>
      <ChangeableContent changed={changed}>
        {camelToTitle(topLevelKey)}:{' '}
      </ChangeableContent>
      {editing && (
        <TextField
          value={itemValue}
          onBlur={onBlur}
          onChange={({ target }) => setItemValue(target.value)}
        />
      )}
      {!editing && <em>{itemValue}</em>}
      <Button onClick={() => setEditing(!editing)}>
        {editing ? 'Done' : 'Edit'}
      </Button>
    </Box>
  )
}
